var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', {
    staticClass: "m-3"
  }, [!_vm.loading ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [['ADD'].includes(_vm.action) ? _c('fieldset', {
    staticClass: "form-group bg-default"
  }, [_c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.onSaveSpalProcess.apply(null, arguments);
      }
    }
  }, [_c('b-form-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "SPAL Title *",
      "label-for": "title"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "id": "title",
      "placeholder": "Type Text"
    },
    model: {
      value: _vm.form.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title", $$v);
      },
      expression: "form.title"
    }
  })], 1)], 1), _c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Upload SPAL Document *",
      "label-for": "attachment"
    }
  }, [_c('b-form-file', {
    attrs: {
      "accept": "application/*",
      "multiple": "",
      "name": "attachment",
      "id": "attachment"
    },
    model: {
      value: _vm.form.attachment,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "attachment", $$v);
      },
      expression: "form.attachment"
    }
  })], 1)], 1)], 1), _c('b-form-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Notes",
      "label-for": "notes"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "id": "description",
      "rows": "3",
      "placeholder": "Type Text ..."
    },
    model: {
      value: _vm.form.notes,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "notes", $$v);
      },
      expression: "form.notes"
    }
  })], 1)], 1)], 1), _c('b-form-row', [_c('b-col', [_c('b-form-group', {
    attrs: {
      "label": "Is Fix SPAL / CONTRACT ?",
      "label-for": "is_fix_spal"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "name": "check-button",
      "switch": "",
      "inline": ""
    },
    model: {
      value: _vm.form.is_fix_spal,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_fix_spal", $$v);
      },
      expression: "form.is_fix_spal"
    }
  }, [_vm._v(" Yes / No ")])], 1)], 1)], 1), _c('div', {
    staticClass: "w-100 d-flex mt-4"
  }, [_c('b-button', {
    staticClass: "mr-2 w-50",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.closeSlideSpalProcess
    }
  }, [_vm._v(" Cancel ")]), _c('b-button', {
    staticClass: "w-50",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.saving
    }
  }, [_vm.saving ? _c('span', {
    staticClass: "spinner-border spinner-border-sm"
  }) : _vm._e(), _vm._v(" Submit ")])], 1)], 1)]) : _vm._e(), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', {
    staticClass: "text-truncate text-center align-middle"
  }, [_vm._v("SPAL Title")]), _c('th', {
    staticClass: "text-truncate text-center align-middle"
  }, [_vm._v("Attachment")]), _c('th', {
    staticClass: "text-truncate text-center align-middle"
  }, [_vm._v(" Description ")]), _c('th', {
    staticClass: "text-truncate text-center align-middle"
  }, [_vm._v("Status")])])]), _c('tbody', [_vm._l(_vm.listHistorySpal, function (row, idx) {
    var _row$project_contract, _row$attachment, _row$comment;
    return [_c('tr', {
      key: "spal-row-" + row.id
    }, [_c('td', {
      staticClass: "align-middle"
    }, [_vm._v(" " + _vm._s(row.title || ((_row$project_contract = row.project_contract) === null || _row$project_contract === void 0 ? void 0 : _row$project_contract.title) || '-') + " ")]), _c('td', {
      staticClass: "text-center align-middle"
    }, [row !== null && row !== void 0 && (_row$attachment = row.attachment) !== null && _row$attachment !== void 0 && _row$attachment.length ? _c('b-button', {
      attrs: {
        "variant": "secondary"
      },
      on: {
        "click": function click($event) {
          var _row$attachment2, _row$attachment2$, _row$attachment2$$fil;
          _vm.handleOpenFilePreview("".concat(_vm.apiUrl, "/download/").concat(row === null || row === void 0 ? void 0 : (_row$attachment2 = row.attachment) === null || _row$attachment2 === void 0 ? void 0 : (_row$attachment2$ = _row$attachment2[0]) === null || _row$attachment2$ === void 0 ? void 0 : (_row$attachment2$$fil = _row$attachment2$.file_url) === null || _row$attachment2$$fil === void 0 ? void 0 : _row$attachment2$$fil.replace('upload/', '')), 'history-spal-attachment');
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" Download ")]) : _c('span', [_vm._v("-")])], 1), _c('td', {
      staticClass: "text-center align-middle"
    }, [_c('b-button', {
      attrs: {
        "variant": "primary"
      },
      on: {
        "click": function click($event) {
          return _vm.openDescription(row);
        }
      }
    }, [_vm._v(" Description ")])], 1), _c('td', {
      staticClass: "text-center align-middle"
    }, [_c('div', {
      staticClass: "text-center cursor-pointer",
      on: {
        "click": function click($event) {
          return _vm.toggleOpen(idx);
        }
      }
    }, [_c('svg', {
      attrs: {
        "width": "18",
        "height": "16",
        "viewBox": "0 0 18 16",
        "fill": "none",
        "xmlns": "http://www.w3.org/2000/svg"
      }
    }, [_c('path', {
      attrs: {
        "d": "M4 10.5H14C14.1427 10.5 14.2617 10.4523 14.357 10.357C14.4523 10.2617 14.5 10.1427 14.5 10C14.5 9.85734 14.4523 9.73833 14.357 9.643C14.2617 9.54767 14.1427 9.5 14 9.5H4C3.858 9.5 3.739 9.54767 3.643 9.643C3.547 9.73833 3.49933 9.85734 3.5 10C3.50067 10.1427 3.54833 10.2617 3.643 10.357C3.73767 10.4523 3.85667 10.5 4 10.5ZM4 7.5H14C14.1427 7.5 14.2617 7.45234 14.357 7.357C14.4523 7.26167 14.5 7.14267 14.5 7C14.5 6.85734 14.4523 6.73834 14.357 6.643C14.2617 6.54767 14.1427 6.5 14 6.5H4C3.858 6.5 3.739 6.54767 3.643 6.643C3.547 6.73834 3.49933 6.85734 3.5 7C3.50067 7.14267 3.54833 7.26167 3.643 7.357C3.73767 7.45234 3.85667 7.5 4 7.5ZM4 4.5H14C14.1427 4.5 14.2617 4.45234 14.357 4.357C14.4523 4.26167 14.5 4.14267 14.5 4C14.5 3.85734 14.4523 3.73834 14.357 3.643C14.2617 3.54767 14.1427 3.5 14 3.5H4C3.858 3.5 3.739 3.54767 3.643 3.643C3.547 3.73834 3.49933 3.85734 3.5 4C3.50067 4.14267 3.54833 4.26167 3.643 4.357C3.73767 4.45234 3.85667 4.5 4 4.5ZM1.616 14C1.15533 14 0.771 13.846 0.463 13.538C0.155 13.23 0.000666667 12.8457 0 12.385V1.615C0 1.155 0.154333 0.770669 0.463 0.462002C0.771667 0.153335 1.15567 -0.000664511 1.615 2.15517e-06H16.385C16.845 2.15517e-06 17.229 0.154002 17.537 0.462002C17.845 0.770002 17.9993 1.15434 18 1.615V15.133C18 15.493 17.8343 15.7413 17.503 15.878C17.1717 16.0147 16.8797 15.9567 16.627 15.704L14.923 14H1.616ZM15.35 13L17 14.644V1.616C17 1.462 16.936 1.32067 16.808 1.192C16.68 1.06334 16.539 0.999335 16.385 1H1.615C1.46167 1 1.32067 1.064 1.192 1.192C1.06333 1.32 0.999333 1.461 1 1.615V12.385C1 12.5383 1.064 12.6793 1.192 12.808C1.32 12.9367 1.461 13.0007 1.615 13H15.35Z",
        "fill": "black"
      }
    })]), _c('div', [_vm._v("Comment")])])])]), _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.openIndex === idx,
        expression: "openIndex === idx"
      }],
      key: "spal-collapse-" + row.id
    }, [_c('td', {
      staticClass: "p-0",
      attrs: {
        "colspan": "4"
      }
    }, [_c('div', {
      staticClass: "timeline p-3"
    }, [!(row !== null && row !== void 0 && (_row$comment = row.comment) !== null && _row$comment !== void 0 && _row$comment.length) ? _c('div', {
      staticClass: "text-muted pl-4 pb-2"
    }, [_vm._v(" No comments yet. ")]) : _vm._e(), _vm._l(row.comment, function (c) {
      return _c('div', {
        key: c.id,
        staticClass: "timeline-item"
      }, [_c('div', {
        staticClass: "timeline-dot"
      }, [_c('div', {
        staticClass: "timeline-dot-inner"
      })]), _c('div', {
        staticClass: "timeline-content"
      }, [_c('div', {
        staticClass: "font-weight-bold"
      }, [_vm._v(_vm._s(c.user_name))]), _c('div', {
        staticClass: "text-primary small"
      }, [_vm._v(" " + _vm._s(_vm.moment(c.created_at).format('ddd, DD MMMM YYYY HH:mm')) + " ")]), _c('div', {
        staticClass: "mt-1"
      }, [_vm._v(_vm._s(c.comment))])])]);
    }), _c('div', {
      staticClass: "chat-footer p-3 bg-white"
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('div', {
      staticClass: "chat-attachment d-flex align-items-center"
    }, [_c('b-dropdown', {
      staticClass: "m-0 p-0",
      attrs: {
        "size": "lg",
        "variant": "none",
        "toggle-class": "text-decoration-none",
        "dropleft": "",
        "no-caret": ""
      },
      scopedSlots: _vm._u([{
        key: "button-content",
        fn: function fn() {
          return [_c('h6', {
            staticClass: "m-0 p-0"
          }, [_c('i', {
            staticClass: "fa fa-smile-o"
          })])];
        },
        proxy: true
      }], null, true)
    }, [_c('b-dropdown-item', {
      attrs: {
        "href": "#"
      }
    }, [_c('VEmojiPicker', {
      on: {
        "select": _vm.addEmoji
      }
    })], 1)], 1), _c('div', {
      staticClass: "d-inline-block",
      attrs: {
        "id": "file-upload"
      }
    }, [_c('i', {
      staticClass: "fa fa-paperclip pr-3",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "aria-hidden": "true"
      },
      on: {
        "click": _vm.openFileInput
      }
    })]), _c('b-form-file', {
      staticClass: "border p-2",
      attrs: {
        "id": "file-upload",
        "plain": "",
        "accept": "application/*",
        "multiple": "",
        "name": "attachment"
      },
      model: {
        value: _vm.formComment.attachment,
        callback: function callback($$v) {
          _vm.$set(_vm.formComment, "attachment", $$v);
        },
        expression: "formComment.attachment"
      }
    })], 1), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.formComment.comment,
        expression: "formComment.comment"
      }],
      staticClass: "form-control mr-3",
      attrs: {
        "type": "text",
        "placeholder": "Type your message"
      },
      domProps: {
        "value": _vm.formComment.comment
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) return;
          _vm.$set(_vm.formComment, "comment", $event.target.value);
        }
      }
    }), _c('button', {
      staticClass: "btn btn-primary d-flex align-items-center p-2",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.onAddComment(_vm.listHistorySpal[idx].id);
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-paper-plane",
      attrs: {
        "aria-hidden": "true"
      }
    }), _c('span', {
      staticClass: "d-none d-lg-block ml-1"
    }, [_vm._v("Send")])])]), _vm.formComment.attachment.length > 0 ? _c('div', {
      staticClass: "d-flex mt-2 align-items-center"
    }, [_c('span', {
      staticClass: "mr-2"
    }, [_c('strong', [_vm._v(_vm._s(_vm.formComment.attachment.length))]), _vm._v(" Attachment ")]), _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": _vm.resetAttachmentComment
      }
    }, [_c('i', {
      staticClass: "fa fa-trash text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()])], 2)])])];
  })], 2)])])]) : _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "alert alert-info m-4"
  }, [_vm._v("Loading...")])]), _c('b-modal', {
    attrs: {
      "id": "spal-desc-modal",
      "title": "Description",
      "hide-footer": ""
    },
    model: {
      value: _vm.showDescriptionModal,
      callback: function callback($$v) {
        _vm.showDescriptionModal = $$v;
      },
      expression: "showDescriptionModal"
    }
  }, [_vm.selectedDescription ? _c('div', {
    staticClass: "whitespace-pre-wrap"
  }, [_vm._v(" " + _vm._s(_vm.selectedDescription) + " ")]) : _c('div', {
    staticClass: "text-muted"
  }, [_vm._v("No description.")])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }